module.exports = __webpack_public_path__ + "static/media/Horatio Seymour - 1868.b9cbc1eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Horatio Seymour - 1868.jpg
// module id = 493
// module chunks = 0